import i18n from 'src/modules/i18n';

export const quizQuestionFlagOptions = (): Record<
  string,
  { label: string; value: string }
> => ({
  wrong_question: {
    label: i18n.t('quiz.questionFlagOptions.wrongQuestion'),
    value: 'wrong_question',
  },
  no_correct_answer: {
    label: i18n.t('quiz.questionFlagOptions.noCorrectAnswer'),
    value: 'no_correct_answer',
  },
  not_in_the_lesson: {
    label: i18n.t('quiz.questionFlagOptions.notInTheLesson'),
    value: 'not_in_the_lesson',
  },
  other: {
    label: i18n.t('quiz.questionFlagOptions.other'),
    value: 'other',
  },
});

export enum LocalStorageKey {
  FAMILY_USER_ID = 'familyUserId',
  BABZ_WON = 'BABZ_WON',
  HAS_DONE_ONBOARDING_FIRST_LESSON = 'HAS_DONE_ONBOARDING_FIRST_LESSON',
  HAS_SEEN_CONTACT_SUPPORT_PANEL = 'HAS_SEEN_CONTACT_SUPPORT_PANEL',
  CANCELLED_LESSONS_COUNT = 'CANCELLED_LESSONS_COUNT',
  HAS_SEEN_REFERRAL_PAGE = 'HAS_SEEN_REFERRAL_PAGE',
  HAS_SEEN_PARENT_REFERRAL_PAGE = 'HAS_SEEN_PARENT_REFERRAL_PAGE',
  VSAQ_CHAT_INTRO_HIDDEN = 'VSAQ_CHAT_INTRO_HIDDEN',
  HAS_OPENED_VSAQ_BAO = 'HAS_OPENED_VSAQ_BAO',
  DYSLEXIA_SETTINGS = 'baobab-dyslexia-settings',
  HAS_SEEN_FLASHCARDS_TOUR = 'HAS_SEEN_FLASHCARDS_TOUR',
  HAS_SEEN_BLOCK_TERM_TOUR = 'HAS_SEEN_BLOCK_TERM_TOUR',
  HAS_SEEN_HEARTS_INTRO = 'HAS_SEEN_HEARTS_INTRO',
  HAS_SEEN_TUTOR_CONVERSATION_SAVED = 'HAS_SEEN_TUTOR_CONVERSATION_SAVED',
  CAMERA_SESSION = 'baobab_camera_session',
  CAMERA_REDIRECT = 'baobab_camera_redirect',
  DEVICE_PROFILE = 'baobab_device_profile',
  ERROR_RELOAD_TAPS = 'baobab_error_reload_taps',
  IS_SHARED_DEVICE = 'baobab_is_shared_device',
}
